export default "__VITE_IMAGE_ASSET__81f79c48__";